<template>
    <div color="info" class="shadow-sm bg-slate-100 border-white border rounded-lg">
        <analytics-sidebar-title @reset="emit('reset')">
            <slot name="title"></slot>
        </analytics-sidebar-title>

        <div v-if="props.hasContent" class="p-3"><slot></slot></div>
        <div v-if="$slots.actions" class="p-3"><slot name="actions"></slot></div>
    </div>
</template>

<script lang="ts" setup>
import AnalyticsSidebarTitle from './AnalyticsSidebarTitle.vue';

const emit = defineEmits(['reset']);
const props = defineProps({
    hasContent: {
        type: Boolean,
        default: true,
    },
});
</script>
